import { AttackPattern, PatternState } from '../AttackPattern.js';

const ARC_INTERVAL = 0.42; // seconds between successive gobbet fans
const ARC_SPREAD = 0.55; // radians across one fan

/**
 * Regurgitant Volley (The Famished Court) — fans of fat, slow gobbets
 * spat at the player, one fan per course. The count scales with the
 * Court's `gorged` stacks (courtiers devoured during The Feast — see
 * TheFeast.js), which is what makes the Feast's economy legible: every
 * courtier you let through is one more fan in every volley for the rest
 * of the fight. Slow and readable individually; the threat is accumulation.
 */
export class RegurgitantVolley extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'Regurgitant Volley', telegraphDuration: 0.8, activeDuration: 2.8, minPhase });
    this.config = config;
  }

  onBegin(boss, player) {
    this._arcsLeft = Math.min(6, this.config.baseArcs + (boss._gorged ?? 0));
    this._arcTimer = 0;
    this._aimX = player.x;
    this._aimY = player.y;
  }

  onActiveTick(dt, boss, player, pool) {
    this._arcTimer -= dt;
    if (this._arcTimer > 0 || this._arcsLeft <= 0) return;
    this._arcTimer = ARC_INTERVAL;
    this._arcsLeft--;

    const aim = Math.atan2(player.y - boss.y, player.x - boss.x);
    const pellets = Math.min(8, this.config.pellets + boss.phase);
    for (let i = 0; i < pellets; i++) {
      const angle = aim + (i / (pellets - 1) - 0.5) * ARC_SPREAD;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * this.config.speed,
        vy: Math.sin(angle) * this.config.speed,
        radius: 3.4,
        damage: this.config.damage,
        color: '#cdd45a',
        lifetime: 4.5,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return {
      kind: 'fanPreview',
      x: boss.x,
      y: boss.y,
      angle: Math.atan2(this._aimY - boss.y, this._aimX - boss.x),
      spread: ARC_SPREAD,
      arcs: this._arcsLeft,
      pellets: Math.min(8, this.config.pellets + boss.phase),
      color: '#cdd45a',
    };
  }
}
